import i18next from 'i18next';

// TODO: Need to revise the alt texts with the client.
i18next.addResources('en', 'classes', {
  STRENGTH_TITLE: 'Strength \nruns \neverything',
  CLASSES_TITLE: 'Pick your \nendorphin high',
  STRENGTH_CONTENT_1:
    'It beats out cardio. It puts cables to shame. Strength training’s ability to burn calories, build muscle, and improve your heart health is peerless because it gets deep. Breaking down muscles to build you back stronger, burning calories long after you put down your final weight.',
  STRENGTH_CONTENT_2:
    'At Pivot, we’re obsessed with strength training because we want to squeeze the most out of every second of your workout —because your time, your body, and your life, deserves it.',
  STRENGTH_IMAGE_1_ALT_TEXT: 'Person movement on red background',
  STRENGTH_IMAGE_2_ALT_TEXT: 'Guy with weights on blue background',
  LEADERBOARD_IMAGE_ALT_TEXT: 'Leaderboard Pivot',
  LEADERBOARD_TITLE: 'Beat the \nleader',
  LEADERBOARD_TEXT:
    'Prepare yourself for some friendly competition. Pivot’s\n leaderboard is a live, constantly computing standing of how\n your rep count compares with your friends and greater Pivot\n community—giving you extra motivation to push yourself\n just a curl farther.',
  COACHES_TITLE: 'Your \ncoaches'
});
